export default function () {
    let context = undefined;
    return {
        get: (key) => {
            return context === null || context === void 0 ? void 0 : context[key];
        },
        set: (value) => {
            if (context)
                return;
            context = value;
        }
    };
}
